import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { EventEntity } from './event.entity';

/**
 * Polymorphic link table for associating events (tasks) with various entity types.
 * Replaces the individual junction tables (event_client, event_issue, etc.)
 * with a unified approach.
 */
@Index('UK_event_link', ['fkEventId', 'entityType', 'entityId'], {
	unique: true,
})
@Index('idx_event_link_entity', ['entityType', 'entityId'], {})
@Index('idx_event_link_event', ['fkEventId'], {})
@Entity('event_link')
export class EventLinkEntity extends BaseEntity {
	@Column('int', { name: '_fk_event__id', unsigned: true })
	public fkEventId!: number;

	@Column('varchar', { name: 'entity_type', length: 50 })
	public entityType!: string;

	@Column('int', { name: 'entity_id', unsigned: true })
	public entityId!: number;

	@ManyToOne(() => EventEntity, (event) => event.eventLinks, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_event__id', referencedColumnName: 'id' }])
	public fkEvent!: EventEntity;
}
